import { useEffect } from "react";

export const useScrollHandler = (closest: string, setClosest: React.Dispatch<React.SetStateAction<string>>) => {
  return useEffect(() => {
    const scroller = document.getElementsByTagName('main')?.[0];
    const handleScroll = () => {
      const titles = Array.from(document.getElementsByClassName('title'));
      const scroller = document.getElementsByTagName('main')?.[0];
      if (!scroller) return;
      let closest = '';
      for (const element of titles) {
        if (scroller.scrollTop > (element as HTMLElement).offsetTop - scroller.clientHeight * 0.3) {
          closest = (element as HTMLElement).id;
        }
      }
      setClosest(closest);
    }
    if (scroller) {
      scroller.addEventListener('scroll', handleScroll);
      return () => scroller.removeEventListener('scroll', handleScroll);
    }
  // eslint-disable-next-line
  }, [closest]);
}